import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { LoanApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';
import { useSelector } from 'react-redux';
import { BfiDataGrid, Column, MasterDetail } from '../../common/SharedComponents';
import { GridSettingType, LoanStatusType, LoanTypeOptions } from '@apply/constants';
import { onRenderPortfolioGrid, onBorrowerCellRender, onActionCellRender, onRowPrepared } from '../common/LoanFunctions';
import { OnOpenLoanSummary } from '../common/functions/onOpenLoanSummary';
import { LoanCommitOrApprovalColumn } from '../../common/SharedComponents';
import { formatLoanTermShort } from '../common/functions/getLoanTermOptions';

const onTermCellRender = (e) =>
    formatLoanTermShort(
        e.data.loanTypeId,
        e.data.initialTermMonths,
        e.data.contractualExtension1Months,
        e.data.contractualExtension2Months
    );

const RecycleBinTable = ({ gridStore }) => {
    const searchState = useSelector((state) => state.searchState);
    const loanApi = new LoanApi.LoanApi(applicationInsights);
    const location = useLocation();

    const [dataStore, set_dataStore] = useState(gridStore?.store);

    const dataFunction = (criteria) => loanApi.getRecycleBin(criteria);

    useEffect(() => {
        if (gridStore) {
            gridStore.setOnLoad('id', dataFunction, searchState?.searchText?.loanRecycleBin);
            set_dataStore(gridStore.store);
        }
    }, [gridStore]);

    const onLoanTypeRender = (e) => {
        if (!e.value) {
            return null;
        }
        var typeOption = LoanTypeOptions.find((l) => l.id === e.value);
        if (!typeOption) {
            return null;
        }
        return typeOption.shortName;
    };

    return (
        <BfiDataGrid
            gridType={GridSettingType.RecycleBinTable}
            dataStore={dataStore}
            applicationInsights={applicationInsights}
            onRowPrepared={onRowPrepared}
            onCellDblClick={(e) => OnOpenLoanSummary(e, location)}
        >
            <Column
                dataField='borrowerEntity'
                caption='Entity'
                cellRender={onBorrowerCellRender}
                name='borrowerEntity'
                minWidth={120}
            />
            <Column
                dataField='borrowerCity'
                caption='Borr. City'
                dataType='string'
                width={90}
            />
            <Column
                dataField='borrowerState'
                caption='State'
                dataType='string'
                width={70}
            />
            <Column
                dataField='bfiNumber'
                caption='BFI #'
                dataType='string'
                width={120}
            />
            <Column
                dataField='loanNumber'
                caption='Loan #'
                dataType='string'
                width={80}
            />
            <Column
                dataField='loanTypeId'
                caption='Type'
                cellRender={onLoanTypeRender}
                width={100}
                alignment='left'
            />
            <Column
                dataField='initialTermMonths'
                caption='Term'
                dataType='string'
                width={60}
                alignment={'left'}
                cellRender={onTermCellRender}
            />
            {LoanCommitOrApprovalColumn({ statusId: LoanStatusType.Deleted })}
            <Column
                dataField='pointOfContact'
                caption='POC'
                dataType='string'
                width={110}
            />
            <Column
                dataField='ownerName'
                caption='User'
                dataType='string'
                width={110}
            />
            <Column
                dataField='broker'
                dataType='string'
                width={110}
            />
            <Column
                alignment='center'
                cellRender={onActionCellRender}
                width={50}
                allowReordering={false}
                allowSorting={false}
                allowResizing={false}
                type='actions'
                fixed={true}
                fixedPosition={'right'}
            />
            <MasterDetail
                enabled={true}
                render={(e) => onRenderPortfolioGrid(e, LoanStatusType.Deleted)}
            />
        </BfiDataGrid>
    );
};

export default RecycleBinTable;
